import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoader } from 'routes/PrivateRouter';
import {
  consolidationURLs,
  type ConsolidationTab,
} from 'routes/consolidation/consolidationURLs';

import { PermissionGuard } from 'components/PermissionGuard';

// lazy load consolidation component
const Consolidation = lazy(() =>
  import('pages/reporting/consolidation/Consolidation').then((m) => ({
    default: m.Consolidation,
  }))
);

const ConsolidationRouteElement = ({ tab }: { tab: ConsolidationTab }) => (
  <PermissionGuard moduleKey="consolidation-mapping">
    <Suspense fallback={<PageLoader />}>
      <Consolidation tab={tab} />
    </Suspense>
  </PermissionGuard>
);

export const consolidationRoutes = [
  {
    path: consolidationURLs._base_relative_path,
    children: [
      {
        index: true,
        element: (
          <Navigate to={consolidationURLs.consolidationGroups.base} replace />
        ),
      },
      {
        path: 'consolidation-groups',
        element: <ConsolidationRouteElement tab="consolidation-groups" />,
      },
      {
        path: 'chart-of-accounts',
        element: <ConsolidationRouteElement tab="chart-of-accounts" />,
      },
      {
        path: 'intercompany-sets',
        element: <ConsolidationRouteElement tab="intercompany-sets" />,
      },
    ],
  },
];
